const set = (state, action) => {
    return {
        ...state, cartWorkingItem: {...state.cartWorkingItem, wireLength: action.payload}
    }
}

export default {set}